import { Injectable } from "@angular/core";
import { DataService } from "./data.service";
import { Observer, Observable } from "rxjs";
import { environment } from "src/environments/environment";
// import { JwtHelperService } from '@auth0/angular-jwt';
import * as CryptoJS from 'crypto-js';


@Injectable()
export class AuthService {
    encryptSecretKey = 'Test@1234567890'
    constructor(private dataService: DataService,
        // private jwtHelper: JwtHelperService
    ) {
    }
    // url = environment.login_url;
    url = environment.api_base_url;


    authenticate(data: any): Observable<any> {
        return Observable.create((observer: Observer<any>) => {
            this.dataService.login(this.url + "auth/authenticate", data).subscribe((result) => {
                observer.next(result);
                observer.complete();
            },
                (error: Array<any>) => {
                    observer.error(error);
                    observer.complete();
                });
        });
    }

    logout(): Observable<any> {
        return Observable.create((observer: Observer<any>) => {
            this.dataService.logout(this.url + "auth/logout").subscribe((result) => {
                observer.next(result);
                observer.complete();
            },
                (error: Array<any>) => {
                    observer.error(error);
                    observer.complete();
                });
        });
    }



    setAuthToken(data: any) {
        sessionStorage.setItem("authToken", data);
    }

    getToken() {
        return sessionStorage.getItem("authToken")?.toString();
    }

    setExpires(data: any) {
        sessionStorage.setItem("expires", data);
    }

    getExpires() {
        return sessionStorage.getItem("expires");
    }

    setIsPasswordSet(data: any) {
        sessionStorage.setItem("newPasswordSet", data);
    }

    getIsPasswordSet() {
        return sessionStorage.getItem("newPasswordSet");
    }

    setPBIToken(data: any) {
        data = CryptoJS.AES.encrypt(JSON.stringify(data), this.encryptSecretKey).toString();

        sessionStorage.setItem("access-token", data);
    }

    getPBIToken() {
        let data: string = '';
        let token = sessionStorage.getItem("access-token");
        if (token !== null && token !== '' && token !== undefined) {
            data = token;
        }
        const bytes = CryptoJS.AES.decrypt(data, this.encryptSecretKey);
        if (bytes.toString()) {
            return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        } else {
            return null;
        }

    }

    setPBIExpires(data: any) {
        data = CryptoJS.AES.encrypt(JSON.stringify(data), this.encryptSecretKey).toString();

        sessionStorage.setItem("pbi-expires", data);
    }

    getPBIExpires() {
        let data: string = '';
        let token = sessionStorage.getItem("pbi-expires");
        if (token !== null && token !== '' && token !== undefined) {
            data = token;
        }
        const bytes = CryptoJS.AES.decrypt(data, this.encryptSecretKey);
        if (bytes.toString()) {
            return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        } else {
            return null;
        }

    }

    setPBIRefreshToken(data: any) {
        data = CryptoJS.AES.encrypt(JSON.stringify(data), this.encryptSecretKey).toString();

        sessionStorage.setItem("refresh-token", data);
    }

    getPBIRefreshToken() {
        let data: string = '';
        let token = sessionStorage.getItem("refresh-token");
        if (token !== null && token !== '' && token !== undefined) {
            data = token;
        }
        const bytes = CryptoJS.AES.decrypt(data, this.encryptSecretKey);
        if (bytes.toString()) {
            return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        } else {
            return null;
        }

    }

    getUserAuthInfo() {
        return sessionStorage.getItem("authToken")?.toString();
    }

    resetPasswordRequest(email: any): Observable<any> {
        return Observable.create((observer: Observer<any>) => {
            this.dataService.post(this.url + "auth/reset-password?email=" + email, null).subscribe((result) => {
                observer.next(result);
                observer.complete();
            },
                (error: Array<any>) => {
                    observer.error(error);
                    observer.complete();
                });
        });
    }

    resetPassword(data: any): Observable<any> {
        return Observable.create((observer: Observer<any>) => {
            this.dataService.post(this.url + "auth/save-password", data).subscribe((result) => {
                observer.next(result);
                observer.complete();
            },
                (error: Array<any>) => {
                    observer.error(error);
                    observer.complete();
                });
        });
    }

    updatePassword(data: any): Observable<any> {
        return Observable.create((observer: Observer<any>) => {
            this.dataService.post(this.url + "auth/update-password", data).subscribe((result) => {
                observer.next(result);
                observer.complete();
            },
                (error: Array<any>) => {
                    observer.error(error);
                    observer.complete();
                });
        });
    }

    registerUser(data: any): Observable<any> {
        return Observable.create((observer: Observer<any>) => {
            this.dataService.post(this.url + "auth/register", data).subscribe((result) => {
                observer.next(result);
                observer.complete();
            },
                (error: Array<any>) => {
                    observer.error(error);
                    observer.complete();
                });
        });
    }

    getLoggedInUserInfo(): Observable<any> {
        return Observable.create((observer: Observer<any>) => {
            this.dataService.get(this.url + "auth/user").subscribe((result) => {
                observer.next(result);
                observer.complete();
            },
                (error: Array<any>) => {
                    observer.error(error);
                    observer.complete();
                });
        });
    }

    activateUse(data: any): Observable<any> {
        return Observable.create((observer: Observer<any>) => {
            this.dataService.put(this.url + "auth/user/activate", data).subscribe((result) => {
                observer.next(result);
                observer.complete();
            },
                (error: Array<any>) => {
                    observer.error(error);
                    observer.complete();
                });
        });
    }
}